// Role NAMES are translated: `ROLE_LABEL_KEY` / `PLATFORM_ADMIN_LABEL_KEY` in
// apps/web/src/lib/roles.ts. English labels here rendered on Register, in the
// sidebar for every user and in admin › Users, whatever the locale (removed
// 2026-09-26, uiv2 PUB-06).
/**
 * Roles a new sign-up may ask for — `POST /auth/register` accepts exactly
 * these. `workspace-admin` is not chosen: it is what creating a workspace makes you.
 */
export const RegistrationRoles = ['manager', 'accountant', 'employee'];
// Role hierarchy for permission checks (higher index = more permissions)
export const RoleHierarchy = ['employee', 'accountant', 'manager', 'workspace-admin'];
/**
 * A role as stored or cached before the rename, read as the current one.
 * `admin` and `superuser` both became `workspace-admin`. Anything else that is
 * not a current role is `null` — never a guess.
 *
 * Needed beyond the migration: containers restart BEFORE migrations run, a
 * browser can hold a cached user from before, and an access token outlives a deploy.
 */
export function normalizeRole(value) {
    if (value === 'admin' || value === 'superuser')
        return 'workspace-admin';
    return typeof value === 'string' && RoleHierarchy.includes(value) ? value : null;
}
//# sourceMappingURL=user.js.map